import { lang } from "moment";

/* 简中 */
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "记录",
    emptyRecords: "暂无水果转盘记录",
    guessResult: "竞猜结果",
    myGuesses: "我的竞猜",
    guessFailed: "竞猜失败",
    winningPlayers: "获胜玩家",
    noGuesses: "本局未参与竞猜",
    noWinners: "本局暂无获胜玩家",
    rulesTitle: "玩法说明",
    rulesDescription: "每局50s的竞猜时间，玩家可以竞猜本局开出的水果。竞猜正确将获得对应的露水奖励。",
    guessingTitle: "竞猜方法",
    guessingDescription: "在竞猜时间内，选择您要竞猜的露水数量，点击画面中的水果下注区域进行竞猜。",
    rewardsTitle: "奖励说明",
    rewardsDescription: "竞猜不同的水果将获得不同的露水奖励",
    fruit: "水果",
    multiplier: "奖励倍数",
    apple: "苹果",
    watermelon: "西瓜",
    orange: "橙子",
    banana: "香蕉",
    grape: "葡萄",
  },
  /* 设置社长 */
  setPresident: {
    intro: "您可以设置社长来帮助管理您的社团",
    selfIntro: "您是社团的社长",
    president: "社长",
    empty: "未设置社长",
    appoint: "去任命",
    privileges: "社长职能",
    privilegesIntro: "社长拥有以下职能",
    title: "设置社长",
    selectMember: "选择您要任命为社长的社员",
    member: "社员",
    attendance: "到场{days}天",
    weekContribution: "声望贡献 (周):",
    monthContribution: "(月):",
    confirmAppoint: "是否任命该社员为社长？",
    confirm: "确认",
    remove: "解除任命",
    cancel: "取消",
    removeTitle: "解除社长任命",
    confirmRemove: "是否确认解除社长 {name} 的任命？",
    unnamed: "未命名",
    pkTitle: "PK 房间",
    pkDesc: "社长可以开启、关闭、管理本社团的 PK 房间",
    infoTitle: "社团信息",
    infoDesc: "社长和领主有权限编辑社团封面、名称、宣言等社团信息",
    membersTitle: "社员管理",
    membersDesc: "社长和领主都有权限清除社团的社员、门客",
    rewardsTitle: "社团奖励",
    rewardsDesc: "社长可以领取社团相关的奖励，如果未设置社长，则无法领取",
    moderationTitle: "直播间场控",
    moderationDesc: "社长自动获得领主直播间的场控权限",
    newPlayersTitle: "新玩家频道",
    newPlayersDesc: "社长和领主可以查看新玩家频道",
    loadMembersFailed: "获取社员列表失败",
    appointFailed: "设置社长失败",
    appointSuccess: "设置成功",
    removeFailed: "解除任命失败",
    removeSuccess: "解除成功",
    customerService: "客服",
    loadClubFailed: "获取社团信息失败",
  },
  /* 总榜 */
  allRank: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "团战",
    lang5: "华语",
    lang6: "英语",
    lang7: "泰语",
    lang8: "日语",
    lang9: "印尼语",
    lang10: "越南语",
    lang11: "小时",
    lang12: "日榜",
    lang13: "周榜",
    lang14: "本周",
    lang15: "上周",
    lang16: "月榜",
    lang17: "总榜",
    lang18: "奖励",
    lang19: "接通率",
    lang20: "团积分",
    lang21: "团员",
    lang22: "暂无数据",
    lang23: "暂未登榜",
    lang24: "珍爱团",
    lang25: "约会",
    lang26: "自己不能关注自己哦",
    lang27: "关注成功",
    lang28: "已取消关注",
    lang29: "虚位以待",
    lang30: "昨日",
    lang31: "上月",
    lang32: "未上榜",
    lang33: "我的排名",
    lang34: "使者",
    lang35: "奖励月榜",
    lang36: "人数月榜",
    lang37: "社团",
    lang38: "珍爱团",
    lang39: "暂无宣言",
    lang40: "社员",
    lang41: "成员",
    lang42: "周声望",
    lang43: "总声望",
    lang44: "社团榜单",
    lang45: "分享",
    lang46: "启动",
    lang47: "发来的社团邀请",
    lang48: "启动FIREFLY,发现更多有趣主播",
    lang49: "奖励周榜",
    lang50: "人数周榜",
    lang51: "声望",
    lang52: "奖",
  },

  /* 社团 */
  club: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "团战",
    lang5: "华语",
    lang6: "英语",
    lang7: "泰语",
    lang8: "日语",
    lang9: "印尼语",
    lang10: "越南语",
    lang11: "小时",
    lang12: "日榜",
    lang13: "周榜",
    lang14: "本周",
    lang15: "上周",
    lang16: "月榜",
    lang17: "总榜",
    lang18: "奖励",
    lang19: "接通率",
    lang20: "团积分",
    lang21: "团员",
    lang22: "暂无数据",
    lang23: "暂未<br>登榜",
    lang24: "珍爱团",
    lang25: "约会",
    lang26: "自己不能关注自己哦",
    lang27: "关注成功",
    lang28: "已取消关注",
    lang29: "虚位以待",
    lang30: "积分贡献榜",
    lang31: "排名",
    lang37: "社团",
    lang38: "珍爱团",
    lang39: "暂无宣言",
    lang40: "成员",
    lang41: "成员",
    lang42: "周声望",
    lang43: "总声望",
    lang44: "社团榜单",
    lang45: "分享",
    lang46: "启动",
    lang47: "发来的社团邀请",
    lang48: "启动FIREFLY，加入社团一起玩吧~",
    lang49: "社团",
    lang50: "领主：",
    lang51: "社长：",
    // 社团榜“我的排名”行的角色徽章文案，值为 userclub/get 返回的 role。
    lang52: "领主",
    lang53: "社长",
    lang54: "社员",

    lang55: "无社员归属",

    lang56: "未设置社员归属的社团",
  },

  /* 榜单 */
  rank: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "团战",
    lang5: "华语",
    lang6: "英语",
    lang7: "泰语",
    lang8: "日语",
    lang9: "印尼语",
    lang10: "越南语",
    lang11: "小时",
    lang12: "日榜",
    lang13: "周榜",
    lang14: "本周",
    lang15: "上周",
    lang16: "月榜",
    lang17: "总榜",
    lang18: "奖励",
    lang19: "接通率",
    lang20: "团积分",
    lang21: "团员",
    lang22: "暂无数据",
    lang23: "暂未登榜",
    lang24: "珍爱团",
    lang25: "约会",
    lang26: "自己不能关注自己哦",
    lang27: "关注成功",
    lang28: "已取消关注",
    lang29: "虚位以待",
    lang30: "昨日",
    lang31: "上月",
    lang32: "未上榜",
    lang33: "我的排名",
    newDraw96: "私房",
  },

  /* TOP集合 */
  topRankList: {
    title: "荧光榜单TOP集合",
    playerCoreTitle: "玩家核心TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "主播核心TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "玩家榜集群",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "主播榜集群",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY 富豪榜",
    anchorBoard: "FIREFLY 主播榜",
    clubBoard: "社团榜",
    emissaryBoard: "使者榜",
    mountBoard: "座驾名人榜",
    ludoBoard: "LUDO PK 榜",
    gardenBoard: "萤火花园榜",
    firstLoveBoard: "首礼榜",
    newStarBoard: "新星榜",
    pkBoard: "PK 榜",
    privateCreditBoard: "私房信用榜",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "声望值记录",
    income10: "本月",
    income11: "上月",
    news7: "事项 ",
    news13: "声望值",
    cashreal6: "取消",
    box1: "暂无记录",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "新玩家註册7天内，完成「首充大礼包」储值活动获得「FirstLove」礼物奖励。「FirstLove」礼物送出后将绑定主播为FirstLove， 在直播间发言将有专属标签。每个玩家仅能绑定一个 FirstLove。",
    lang3: "「首充大礼包」入口",
    lang4: "揹包送礼",
    lang5: "FirstLove 首礼榜",
    lang6:
      "FirstLove首礼榜按照主播收到的FirstLove首礼数量进行排行，收到数量更多排名更靠前。如果多名主播收到FirstLove数量一致，",
    lang7: "先达到此数量的主播排名更靠前。",
  },

  /* 社团说明页 */
  groupIntruduction: {
    lang1: "社团の简介",
    lang2:
      "社团是由主播的核心粉丝构成的群体组织。<br/>加速社团可以共同参与趣味活动及竞技,和同样社团里的同好成为朋友。<br/>粉丝群体的数量和声网是社团主要竞争点,也象征创建主播的影响力和人气。",
    lang3: "社团の专门属性介绍",
    lang4: "C.by创建者：",
    lang5:
      "社团的开创者,通常是主播。由主播根据自己的追踪人群达到一定数量后,开通社团。",
    lang6: "P.by会长：",
    lang7:
      "社团的管理者,由主播指定后生效。社团的会长同时成为C.by创建者的直播间场控。",
    lang8: "成员：",
    lang9:
      "社团的成员。加入方式为直播中送出珍爱你或社团粉丝瓶礼物。任何社团成员数量无限制。",
    lang10: "专属礼物：",
    lang11: "社团竞争用专门礼物。送出专属礼物可获得声望值积累。",
    lang12: "声望值：",
    lang13:
      "1.在社团的创建人的直播间送出社团专属礼物,可累积声望值。<br/>2.在社团的创建人的直播间内完成每日社团任务,可累积声望值。",
    lang14: "声望：",
    lang15:
      "同个社团内所有成员的声望值之和,为本社团的声望。社团内所有成员每周增加的声望值之和,为本社团的周声望",
    lang16: "成员の等级",
    lang17:
      "1.累积声望值的过程即为完成升级的过程,具体参考上方图标<br/>2.赠送声望礼物10宝石= 1声望值（不影响礼物其他属性）。<br/>3.当日声望值累积至上限后不在提升。",
    lang18: "成员の降级",
    lang19:
      "1.在社团内,当成员连续3日未贡献任何声望值后,第4日起开始声望值的衰减。<br/>2.声望值的持续衰减会导致成员降级,具体参考成员の等级。<br/>3.声望值降低至0则本成员自动退出该社团。",
    lang20: "成员の特权",
    lang21: "其他",
    lang22:
      "若社团出现刷号、作弊、名字或封面违反所在地法律法规等情形,FIREFLY平台方有权修改或者删除改社团",
    lang23: "社团等级",
    lang24: "升级所需声望值",
    lang25: "每日礼包",
    lang26: "声望值上限",
    lang27: "衰减",
    lang28: "特权",
    lang29: "描述",
    lang30: "社团铭牌",
    lang31: "在C.by创建者的主播直播间的特殊等级标识",
    lang32: "专属礼物",
    lang33: "在C.by创建者的主播直播间的专属礼物",
    lang34: "专属聊天框",
    lang35: "在C.by创建者的主播直播间的专属聊天框",
    lang36: "社团宝箱",
    lang37: "在C.by创建者的主播直播间可以抢夺社团宝箱的特权",
    lang38: "每日礼包",
    lang39: "在C.by创建者的主播直播间内可以完成每日任务领取的礼包",
    lang40: "成员畅聊",
    lang41: "在私信中与社团内所有成员聊天无亲密度限制",
    lang42: "刷新",
    lang43: "客服咨询",
    lang44: "关闭页面",
    lang45: "社团",
    lang46: "Club",
    lang47:
      "社团是玩家与领主共同建立的专属阵营。玩家可以通过加入社团、为社团贡献声望，社团之间争夺荣誉，赢得专属榜单奖励！",
    lang48: "社员归属",
    lang49:
      "每个玩家可以最多设置一个自己的社员归属社团。设置社员归属后，您在该社团中的角色将更改为「社员」。设置社员归属后，获得荣誉声望（榜单冠军、夜间选秀冠军等）、PK房间游戏获胜都将自动贡献到社员归属的社团。",
    lang50: "社团加入/退出",
    lang51:
      "玩家通过赠送领主「瑩心錘」礼物，加入领主所在的社团。送礼加入社团之后的角色为「门客」。玩家可以自己自由选择退出社团。",
    lang52: "声望",
    lang53:
      "声望是社团比拼竞争的核心。声望由社团内的所有成员通过完成社团任务、竞争榜单活动冠军、游戏参与与获胜来贡献给所在的社团。",
    lang54: "社团奖励",
    lang55:
      "社团通过竞争获得奖励时，将发放给社团的社长。如果社团未设置社长，则无法接收社团奖励。",
    lang56: "社团上榜",
    ranked: "已上榜",
    lang57: "社团满足了以下条件可以参与FIREFLY Club 社团榜的排行",
    lang58: "更改了社团名称",
    lang59: "更改了社团封面",
    lang60: "设置了社长",
    lang61:
      "未满足以上条件的社团不影响正常玩家的加入和声望的累计，仅无法参与榜单排行。",
    lang62: "社团角色",
    lang63: "Club Role",
    lang64: "领主 Load",
    lang65:
      "领主是社团的创建人，与社团深度绑定。领主拥有社团的管理与编辑权力，并可以为社团设置社长。",
    lang66: "社长 Boss",
    lang67:
      "由领主任命指定，拥有社团的管理与编辑权限。可以开启所在社团的PK房间。",
    lang68:
      "<span class='highlight-text'>社团奖励：</span>为社团发放的奖励，都将发放给社长。如果社团未设置社长，则无法接收社团奖励。",
    lang69: "社员 Members",
    lang70:
      "已加入该社团，且将该社团设定为「归属社团」的玩家。社员获得的荣誉声望、游戏声望奖励将自动贡献到归属的社团。",
    lang71: "门客 Guest",
    lang72: "已加入该社团，但未将其设定为「归属社团」的玩家。",
    lang73: "王者社团",
    lang74:
      "每周FIREFLY的社团周榜冠军社团，即成为下一周的「王者社团」。王者社团生效期间，门客无法将王者社团设置为社员归属。王者社团的社员在所有直播间都会显示社团名称。",
    lang75: "更多",
  },

  /* 極速狂飈 */
  kingOfSpeed: {
    lang1: "玩法规则",
    lang2: "游戏说明",
    lang3:
      "1.投掷骰子：玩家每次点击投掷骰子消耗1000露水，投掷骰子给队伍的赛车获取加成效果。",
    lang4: "2.骰子机率：6个效果抽取的机率相同，6个面加成效果不同。",
    lang5:
      "3.游戏结果：游戏PK时间结束时行驶距离高的队伍获胜，行驶距离低的队伍失败，如果双方行驶距离相同，则为平局。",
    lang6: "座驾说明",
    lang7: "1.座驾要求：游戏开始时主播若无座驾，当前队伍的赛车无法形成。",
    lang8: "气の等级说明",
    lang9:
      "1.提升等级：双方玩家通过互动为主播增加人气值，人气值用于提升队伍气の等级，气の等级越高骰子的加成效果越强",
    lang10: "2.气の等级要求：",
    lang11: "骰子等级",
    lang12: "人气值",
    lang13: "露水奖池说明",
    lang14:
      "1.露水奖池：双方玩家投掷骰子的露水将累计到露水奖池中，游戏结束后获胜队伍将获得露水奖池中所有的露水作为奖励。游戏平局时，双方队伍的玩家均可获得露水奖池的奖励。",
    lang15:
      "2.奖励分配：根据获胜队伍中每名玩家掷骰子的露水占比分配。没有掷骰子参与游戏的玩家不参与露水奖池的奖励分配。",
    lang16: "3.服务费用：玩家从露水奖池中获得奖励，平台将收取4%的服务费用。",
    lang17: "游戏开发说明",
    lang18:
      "1.玩家可在2025年10月23日 12:00-2025年12月17日 00:00，期间内通过游戏PK参与极速狂飙。",
    lang19: "注意事项",
    lang20: "1.活动内设计的所有时间皆以伺服器时间为准。",
    lang21:
      "2.为确保游戏公平性，游戏中由于不可抗力因素，如网络、作弊等非平台愿意导致活动出现异常，平台有权利调整、暂停等措施。",
    lang22:
      "3.本游戏为休闲娱乐，严禁玩家或主播之间进行线下交易，谨防上当受骗，或谋取不正当利益。",
    lang23: "4.因玩家个人的网络或设备原因导致的游戏损失，平台不承担责任。",
    lang24: "5.游戏最终解释权归平台所有。",
    lang25: "PK游戏记录",
    lang26: "PK时间",
    lang27: "投掷骰子",
    lang28: "PK队伍",
    lang29: "行驶距离",
    lang30: "胜负结果",
    lang31: "加载中...",
    lang32: "没有更多记录了",
    lang33: "暂无游戏PK记录",
    lang34: "对方主播无座驾",
    lang35: "蓝方队伍无座驾",
    lang36: "红方队伍无座驾",
    lang37: "限速到",
    lang38: "速度",
    lang39: "需主播获取座驾加入游戏",
    lang40: "出发",
    lang41: "提示",
    lang42: "当前未拥有座驾，无法进行游戏PK",
    lang43: "前往获取",
    lang44: "露水奖池",
    lang45: "我方",
    lang46: "对方",
    lang47: "投掷",
    lang48: "我投掷的：",
    lang49: "奖池信息",
    lang50: "1.露水奖池：",
    lang51:
      "双方玩家投掷骰子的露水将累计到露水奖池中，游戏结束后获胜队伍将获得露水奖池中所有的露水作为奖励。游戏平局时，双方",
    lang52: "2.奖励分配：",
    lang53:
      "根据获胜队伍中每名玩家掷骰子的露水占比分配。没有掷骰子参与游戏的玩家不参与露水奖池的奖励分配。",
    lang54: "3.服务费用：",
    lang55: "玩家从露水奖池中获得奖励，平台将收取4%的服务费用。",
    lang56: "确定",
    lang57: "提速",
    lang58: "护盾",
    lang59: "蓄能",
    lang60: "红方",
    lang61: "蓝方",
    lang62: "车辆详细信息",
    lang63: "激活中",
    lang64: "未激活",
    lang65: "秒",
    lang66: "速度X2，持续",
    lang67: "保护中",
    lang68: "未保护",
    lang69: "护盾可免疫一次负面效果",
    lang70: "（干扰、限速）",
    lang71: "持续",
    lang72: "激活中",
    lang73: "未激活",
    lang74: "蓄能值满了后激活，赛车速度X3，持续",
    lang75: "提速持续时间",
    lang76: "加速",
    lang77: "加速模式：",
    lang78: "护盾持续时间",
    lang79: "干扰",
    lang80: "干扰模式：",
    lang81: "限速",
    lang82: "赛车获得",
    lang83: "蓄能值，蓄能值到达100%后激活蓄能模式,蓄能模式下速度x3，持续",
    lang84: "时间结束后退出",
    lang85: "蓄能模式",
    lang86: "进度条清零。",
    lang87: "赛车获得提速加成，速度",
    lang88: "持续",
    lang89: "时间结束后速度恢复。",
    lang90: "赛车获得",
    lang91: "加成",
    lang92: "速度",
    lang93: "持续",
    lang94: "可免疫一次",
    lang95: "负面效果",
    lang96:
      "多次获得护盾加成时，护盾层数进行叠加，时间结束或免疫1次后护盾层数减1",
    lang97: "使用干扰效果，向对方投放一个",
    lang98: "干扰物",
    lang99: "生效后使其赛车的普通速度",
    lang100: "使用限速效果，向对方出示减速标识，使其赛车速度降低",
    lang101: "干扰",
    lang102: "限速",
    lang103: "投掷骰子",
    lang104: "投掷骰子获得加成效果",
    lang105: "极速狂飙，并肩冲刺！",
    lang106: "口号已复制到剪贴板，请到输入框粘贴发送！",
    lang107: "复制失败",
    lang108: "参与赛车游戏",
    lnag109: "参与条件",
    lang110: "主播持有座驾",
    lang111: "已达成",
    lang112: "未达成",
    lang113: "加入PK队伍",
    lang115: "点击赠送座驾",
    lang109: "参与条件",
    lang116: "点击发送队伍口号",
    lang117: "当前游戏未开啓，无法进行投掷。",
    lang118: "主播不允许投掷骰子",
    lang119: "极速狂飚，胜者为王！",
    lang120: "游戏未开始",
    lang121: "【极速狂飙】处于未开啓状态无法进行游玩",
    lang122: "赛车获得护盾加成",
    lang123: "无座驾",
    lang124: "领先",
    lang125: "落后",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "上播助手",
    lang2: "绑定玩家为上播助手，玩家奖获得您的收礼的萤火分成",
    lang3: "上播助手",
    lang4: "输入 ID 确认绑定玩家",
    lang5: "输入您要绑定的玩家 ID",
    lang6: "下一步",
    lang7: "萤火分成",
    lang8: "绑定说明",
    lang9:
      "绑定上播助手之后，上播助手将获得您收礼萤火的分成。您通过收礼收穫的萤火，将按照您设定的萤火分成比例发送给上播助手。",
    lang10: "确认",
    lang11: "绑定上播助手",
    lang12: "是否确认绑定",
    lang13: "为您的上播助手",
    lang14: "取消",
    lang15: "绑定成功",
    lang16: "绑定失败",
    lang17: "解绑成功",
    lang18: "解绑失败",
    lang19: "绑定玩家为上播助手，玩家将获得您的收礼的萤火分成",
    lang20: "我的上播助手",
    lang21: "解除绑定",
    lang22: "待确认",
    lang23: "解绑上播助手",
    lang24: "解除上播助手需要对方确认后可以完成解除绑定，是否解除绑定",
    lang25: "为您的上播助手？",
    lang26: "拒绝解绑成功",
    lang27: "拒绝解绑失败",
    lang28: "上播助手设置",
    lang29: "收获萤火",
    lang30: "对方解除绑定您的上播助手身份，需要您进行确认后才可以解除",
    lang31: "解绑申请",
    lang32: "对方已申请解绑您的上播助手身份，请您确认",
    lang33: "拒绝",
    lang34: "绑定我为上播助手的主播列表",
    lang35: "暂无绑定主播",
    lang36: "解绑上播助手",
    lang37: "是否解除绑定您与",
    lang38: "的上播助手关系？",
    lang39: "用户已封禁",
    lang40: "您输入的ID搜索失败",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang1: "活动规则",
    lang2: "实况",
    lang3: "往期",
    lang4: "您已放弃今日参赛",
    lang5: "放弃今日参数失败",
    lang6: "放弃参赛",
    lang7: "我的排名",
    lang8: "胜场",
    lang9: "参赛说明",
    lang10:
      "请晋级半决赛/决赛的主播在半决赛/决赛开始的时间保持开播状态且未在PK中,系统将自动发起半决赛/决赛双方主播的PK。",
    lang11: "半决赛",
    lang12: "5局3胜制,获胜主播晋级决赛",
    lang13: "海选No.1 VS 海选No.4",
    lang14: "海选No.2 VS 海选No.3",
    lang15: "决赛",
    lang16: "5局3胜制,获胜主播成为当日「荧光夜间选秀」冠军",
    lang17: "半决赛胜者",
    lang18:
      "注：如果您满足半决赛/决赛参与条件但无法参与，请在每天20:30之前点击",
    lang20: "缺席比赛将在未来15天无法参加「荧光夜间选秀」活动",
    lang22: "放弃参赛将退出海选阶段排名,次日将恢复您的参赛资格。",
    lang23: "是否放弃参加今日",
    lang24: "的「荧光夜间选秀」活动",
    lang25: "取消",
    lang26: "确认",
    lang27: "胜场",
    lang28: "未完赛",
    lang29: "暂无往期记录",
    lang30: "参与「荧光夜间选秀」",
    lang31:
      "主播使用FIREFLY V54.0以上版本开启PK（包含「人气PK」和「游戏PK」），即可参加「荧光夜间选秀」活动。",
    lang32: "海选",
    lang33: "时间：每日20:30-次日20:30",
    lang34:
      "规则：榜单记录主播当日参与PK的最高人气值，以当日PK场次的最高人气值进行排名",
    lang35: "晋级：截止每日20:30，海选前4名主播晋级半决赛",
    lang36:
      "放弃参赛：如果主播无法在半决赛/决赛的指定时间开播，可以在海选时间段内选择放弃参赛。主播放弃参赛后排名下一位的主播将顶上。",
    lang37: "半决赛",
    lang38: "时间：每日21:00/21:20",
    lang39:
      "规则：系统将在指定时间自动发起半决赛双方主播的PK，PK规则为「人气PK」5局3胜制。请主播在此时间内保持开播状态。",
    lang40: "晋级：赢家将晋级决赛",
    lang41:
      "放弃参赛：主播在半决赛开始时未在开播状态，视为放弃参赛。无法获得名次奖励，并在未来15天无法再次参与「荧光夜间选秀」",
    lang42: "半决赛对阵：每日海选结束后由系统随机抽签产生",
    lang44: "半决赛失败方根据当日最高人气值排名，决出No.3/No.4",
    lang45: "决赛",
    lang46: "时间：每日22:00",
    lang47:
      "规则：系统将在指定时间自动发起决赛双方主播的PK，PK规则为「人气PK」5局3胜制。请主播在此时间内保持开播状态。",
    lang48: "晋级：赢家获得当日「荧光夜间选秀」冠军",
    lang49:
      "放弃参赛：主播在决赛开始时未在开播状态，视为放弃参赛。无法获得名次奖励，并在未来15天无法再次参与「荧光夜间选秀」",
    lang50: "决赛胜利方为当日冠军，失败方为当日No.2",
    lang51: "奖励",
    lang52: "玩家露水奖励：",
    lang53: "半决赛1：获胜方的队伍将平分",
    lang54: "半决赛2：获胜方的队伍将平分",
    lang55: "决赛：获胜方的队伍将平分",
    lang56: "主播积分奖励：",
    lang57:
      "参与半决赛/决赛的主播，决出胜负之后，前4名可以获得「直播奖励」的积分。放弃参赛的主播将无法获得积分奖励。具体积分请查看",
    lang58: "「直播奖励」>",
    lang59: "注意事项",
    lang60: "1.活動僅限女性主播參與",
    lang61:
      "2.被限制活动参与资格期间，所有活动数据均为无效数据，需在解除限制后重新获取",
    lang62:
      "3.主播需积极与玩家互动，有违反《主播直播公约》以及破坏活动平衡的行为，平台有权取消其活动资格以及活动积分（包括但不限于挂脸直播、无质量、黑屏、挂机、直播打游戏、看电视、串通PK结果、消极比赛等）。违反以上规则的主播，平台将处以「红牌惩罚」。",
    lang63: "4.活动最终解释权归平台所有",
    lang64: "海选中",
    lang65: "20:30-次日20:30",
    lang66:
      "开啓PK即可参与海选排名,榜单记录当日PK最高人气值,排名前4名晋级半决赛",
    lang67: "晋级区",
    lang68: "暂无海选记录",
    lang69: "「FIREFLY」您预约了荧光夜间选秀决赛",
    lang70: "每天21:00-23:00，PK赢露水奖励",
    lang71: "决赛主播未决出",
    lang72: "半决赛主播未决出",
    lang74: "海选NO.1",
    lang75: "海选NO.2",
    lang76: "海选NO.3",
    lang77: "海选NO.4",
    lang78: "订阅提醒 >",
    lang79: "获胜队伍奖励",
    lang80: "五局三胜",
    lang81: "已锁榜",
    lang82: "暂无排名",
    lang83: "「FIREFLY」您预约了荧光夜间选秀半决赛1",
    lang84: "「FIREFLY」您预约了荧光夜间选秀半决赛2",
    lang85: "加载更多中...",
    lang86: "向下滑动加载更多",
    lang87: "暂无更多了",
    lang88: "红牌处罚：",
    lang89: "a.取消当日「荧光夜间选秀」的奖励领取资格",
    lang90: "b.未来5天禁止参与「荧光夜间选秀」活动",
    lang91: "奖励",
    lang92: "每天「荧光夜间选秀」中获得前四名的主播，可获得奖励",
    lang93: "冠军",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "其他名次",
    lang97: "无奖励",
    lang98: "领取",
    lang99: "未获得荧光夜间选秀奖励",
    lang100: "已領取",
    lang101: "您已领取荧光夜间选秀奖励",
    lang102: "领取成功",
    lang103: "主播可獲得寶石獎勵：",
    lang104: "冠軍：",
    lang105: "第二名：",
    lang106: "第三名/第四名：",

    lang107: "决赛奖励",
    lang108: "结果",
    lang109: "奖励",
    lang110: "胜",
    lang111: "负",
    lang112: "未完赛",
    lang123: "无奖励",
    lang124: "半决赛奖励",
    lang125: "海选奖励",
    lang126: "決賽獎勵",
    lang127: "參與「熒光夜間選秀」決賽，決賽結束後可領取",
    lang128: "半決賽獎勵",
    lang129: "參與「熒光夜間選秀」半決賽，決賽結束後可領取",
    lang130: "海選獎勵",
    lang131: "參與「夜間選秀決賽」獲得前八名可領取，每天21:00 發放",
    lang132: "未開始",
    lang133: "PK中",
    lang134: "已結束",
    lang135: "暂无可领取奖励",
    lang136: "您已领取过奖励",
    lang137: "參與熒光夜間選秀PK,每日贏",
    lang138: "領取",
    lang139: "已領取",
    lang140: "領取獎勵",
    lang141: "我的獎勵",
    lang142: "中",
    lang143: "NO.1-NO.4",
    lang144: "海選排名",
    lang145: "NO.5-NO.8",
    lang146: "無獎勵",
    lang147: "其他排名",
    lang148: "未参赛",
    lang149: "獎勵區",
    lang150: "请更新APP到V57.0版本以上领取奖励！",
    lang151: "赛段结果",
    lang152: "今日夜间选秀决出最终名次后可领取",
    lang153: "海选Top4",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "每日奖励",
    lang2: "奖励记录",
    lang3: "迎新任务",
    lang4: "积分",
    lang5: "完成「迎新 PK」，每天最多可领6000积分",
    lang6: "迎新PK",
    lang7: "每完成1场「迎新PK」(60分鐘)，根据 PK 结果领取积分奖励",
    lang8: "场",
    lang9: "已获得",
    lang10: "领取",
    lang11: "已领取",
    lang12: "积分兑换",
    lang13: "我的积分",
    lang14: "奖励",
    lang15: "阶",
    lang16: "累计积分达到",
    lang19: "积分奖励",
    lang20: "迎新奖励",
    lang21: "每日开启迎新PK，专属流量扶持",
    lang25: "赞",
    lang26: "暂无数据",
    lang27: "迎新奖励规则",
    lang28: "迎新PK",
    lang29:
      "迎新主播在发起 PK 时，选择「迎新PK」并开始匹配。迎新 PK 比拼双方主播的按赞数。",
    lang30: "获得赞的方式：",
    lang31: "新玩家专属礼物",
    lang32: "专属礼物说明：",
    lang33: "礼物名称：",
    lang34: "获取方式：",
    lang35:
      "新注册玩家将免费获得该礼物，有效期48小时。可以在直播间内点击「新人好礼」领取。",
    lang36: "按赞",
    lang37: "FirstLove",
    lang38:
      "新玩家注册7天内，完成「首充大礼包」储值活动获得「FirstLove」礼物奖励。",
    lang39: "您已领取过今天的积分",
    lang40: "未达到奖励要求，无法领取积分",
    lang41: "成功领取迎新奖励积分",
    lang42: "迎新流量扶持",
    lang43:
      "开启「迎新 PK」，将会获得迎新流量扶持。迎新PK 期间新注册的玩家将主动推送到「迎新 PK」的直播间。",
    lang44: "积分领取",
    lang45: "完成「每日奖励」赢取积分，累计积分达到相应等级即可领取萤火奖励",
    lang46: "注意事项",
    lang47: "1.活动仅限女性主播参与",
    lang48: "3.每台设备仅限一个账号领取，多账号领取将被取消活动资格不再恢复",
    lang49:
      "4.被限制活动参与资格期间，所有活动数据均为无效数据，需在解除限制后重新获取",
    lang50:
      "5.「每日奖励」积分需自行领取，请在2025年12月03日 12:00前进行领取，过期不再补发",
    lang51:
      "6.已有邀请人绑定的账号不允许开小号直播领取积分，发现后取消所有账号参与资格不再恢复",
    lang52:
      "7.无邀请人绑定的账号不受大小号限制，视情况给予参与资格，但只能选择一个账号参与奖励活动",
    lang53:
      "8.主播需积极与玩家互动，有违反《主播直播公约》以及破坏活动平衡的行为，平台有权取消其活动资格以及活动积分（包括但不限于挂脸直播、无质量、黑屏、挂机、直播打游戏、看电视等）",
    lang54: "9.活动最终解释权归平台所有",
    lang55: "2.活动时长每两分钟统计一次",
    lang57: "胜",
    lang58: "平",
    lang59: "负",
    lang60: "奖励一阶",
    lang61: "奖励二阶",
    lang62: "奖励三阶",
    lang63: "奖励四阶",
    lang64: "奖励等级",
    lang65: "积分要求",
    lang66: "积分达到",
    lang67: "可领取",
    lang68: "积分兑换成功",
    lang69: "按赞",
    lang70: "赞",
    lang71: "您已领取过当天的积分",
    lang72: "獲得按贊的方式",
    lang73: "發言（最高20條）",
    lang74: "追蹤",
    lang75: "贈送按贊禮物",
    lang76: "贈送FirstLove",
    lang77: "互動",
    lang78: "按贊數",
  },

  /* 合作联系 */
  cooperate: {
    lang1: "你的留言已提交成功！",
    lang2: "你的昵称",
    lang3: "联系媒介：",
    lang4: "联系方式：",
    lang5:
      "非常感谢您的合作留言，以及给FIREFLY的成长意见，会有工作人员与您取得联系。请留意您留下的联系方式。",
    lang6: "主播合作介绍",
    lang7: "查看使者主页",
    lang8: "返回首页",
    lang9:
      "FIREFLY的主播或者用户邀请者、公会人员，成为使者，可以和自己邀请对象成为信中关系，获得长期奖励。优秀的使者还将能自动获得社区内的特权",
    lang10: "请留下您的联系方式",
    lang11: "请留下您的另一种联系方式（选填）",
    lang12: "您想给到FIREFLY的留言",
    lang13: "请填写您想给到FIREFLY的留言",
    lang14: "确认提交",
    lang15: "选择联系媒介",
    lang16: "微信 Wechat",
    lang17: "主播合作",
    lang18: "独立主播自助加入FIREFLY",
    lang19: "使者合作",
    lang20: "以公会方式加入FIREFLY",
    lang21: "商务合作",
    lang22: "推广与媒介",
    lang23: "玩家意见",
    lang24: "FIREFLY玩家意见提交管道",
    lang25: "合作联系",
    lang26: "请填写您的FIREFLY ID",
    lang27: "请填写您的Whatsapp ID",
    lang28: "请填写您的Telegram ID",
    lang29: "请填写您的Facebook ID",
    lang30: "请填写您的Email",
    lang31: "请填写您的Wechat",
    lang32: "请填写您的Line",
    lang33: "请稍后重试",
    lang34: "请输入您的昵称",
    lang35: "请输入您的联系方式",
    lang36: "请输入您的留言",
  },

  /* 靓号启用承诺书 */
  premiumNumberCommitLetter: {
    lang1: "靓号启用承诺书",
    lang2: "亲爱的",
    lang3: "原ID：",
    lang4: "您申请的靓号",
    lang5: "即将为您启用。为维护平台秩序与账号安全，请仔细阅读并同意以下约定：",
    lang6:
      "因您现在获得的靓号，是FIREFLY社区稀缺且不可再生资源，这类账号转让会对社区的稳定和结构造成负面影响。",
    lang7: "【承诺约定】",
    lang8:
      "1.本人承诺，该靓号仅限本人使用，不会以任何形式（包括但不限于出售、出租、赠与、转让）提供给第三方。",
    lang9:
      "2.本人知晓，若违反上述承诺，平台有权收回该靓号，并可能对原账号进行限制处理（如封禁、降权等）。",
    lang10:
      "3.本人承诺遵守平台相关用户协议及法律法规，不利用靓号进行违规或违法行为。",
    lang11: "本承诺一经签署即具有约束力。感谢您的理解与配合。",
    lang12: "我不同意",
    lang13: "我同意",
    lang14: "用户已同意",
    lang15: "同意时间：",
    lang16: "已提交迁移申请",
    lang17: "具体迁移时间会有专属客服与您沟通，感谢您的理解与支持～",
    lang18: "我知道了",
    lang19: "您已成功申请，感谢您的理解与支持～",
    lang20: "刷新",
    lang21: "客服咨询",
    lang22: "关闭页面",
    lang23: "更多",
  },

  /* VIP升级公告 */
  vipUpPublicNotice: {
    lang1: "为了给您带来更加尊贵、专属的互动体验，我们将于 ",
    lang2: "2026年8月4日",
    lang3: "正式上线全新的富豪等级体系",
    lang4:
      "本次调整将划分部分VIP等级所需富豪值，并新增配置更丰富、更震撼的特权权益。以下是主要变化说明：",
    lang5: "新体系更新上线后，原有富豪等级将 ",
    lang6: "自动根据富豪值继承",
    lang7: " 至新体系中对应VIP等级",
    lang8:
      "如您之前的富豪等级是VIP43，富豪值为3254120，现等级平移继承为VIP45，富豪值不变，并获得对应的VIP等级特权！",
    lang9: "权益类型",
    lang10: "具体特权",
    lang11: "解锁等级",
    lang12: "身份隐藏",
    lang13: "隐身",
    lang14: "管理豁免",
    lang15: "防踢防禁言",
    lang16: "个性座驾",
    lang17: "定制专属座驾",
    lang18: "靓号体系",
    lang19: "6位 / 5位 / 4位靓号",
    lang20: "弹幕炫彩",
    lang21: "3色 / 5色自定义",
    lang22: "专属服务",
    lang23: "专属客服通道",
    lang24: "充值特惠",
    lang25: "专属充值通道",
    lang26: "名片美化",
    lang27: "静态/动态个人名片背景",
    lang28: "定制礼物",
    lang29: "中级礼物（5秒） / 高级礼物（10秒）",
    lang30: "全站通知",
    lang31: "上线全站通知",
    lang32: "在平台发展过程中，我们将 ",
    lang33: "不断完善VIP等级特权以及服务体验",
    lang34: "，如有特权规则或权益等变更，我们将及时发布调整公告，敬请留意。",
    lang35: "Firefly保留最终解释权",
  },

  // Ludo
  ludo: {
    clubPkRoom: "{club}的 PK 房间",
    lang1: "开启房间",
    lang2: "快速加入",
    lang3: "入场",
    lang4: "等待中",
    lang5: "当前暂无Ludo PK 房间",
    lang6: "玩法模式",
    lang7: "默认俱乐部",
    lang8: "经典",
    lang9: "无限制",
    lang10: "战绩",
    lang11: "排行",
    lang12: "入场露水",
    lang13: "玩法信息",
    lang16: "支付入场露水加入Ludo PK",
    lang17: "玩家人数",
    lang18: "获胜奖励",
    lang19: "声望",
    lang20: "我的道具",
    lang21: "棋子",
    lang22: "棋盘",
    lang23: "选择您在LUDO游戏中使用的棋子道具。",
    lang24: "选择您的社团PK房间在LUDO游戏中使用的棋盘道具。",
    lang26: "已选择",
    lang27: "默认",
    lang28: "请选择道具",
    lang31: "使用",
    lang32: "点击选择要使用的道具",
    lang33: "点击使用，下一场LUDO游戏将使用该棋盘道具",
    lang34: "点击使用，下一场LUDO游戏将使用该棋子道具",
    lang35: "已在使用中",
    lang36: "请选择要使用的道具",
    lang37: "使用成功，下一场LUDO游戏生效",
    lang38: "天",
    lang39: "小时",
    lang40: "分钟",
    lang42: "当前暂无LUDO PK记录",
    lang43: "游戏详情",
    lang45: "房费",
    lang46: "时间",
    lang47: "露水",
    lang49: "日期",
    lang50: "总计",
    lang51: "玩家头像",
    lang52: "排名",
    lang57: "加载中...",
    lang58: "客服",
    lang59: "胜",
    lang60: "负",
    lang61: "平",
    lang62: "玩法说明",
    lang63: "游戏规则",
    lang64: "玩法人數",
    lang66: "胜负判定",
    lang68: "社团声望",
    lang69: "参与游戏",
    lang70: "中途加入",
    lang72: "起飞",
    lang73: "三連六",
    lang74: "行动",
    lang75: "疊子",
    lang76: "吃子",
    lang77: "安全區",
    lang78: "2-4人",
    lang79:
      "经典：玩家的棋子都需要从起点开始绕图一圈后到达终点，所有棋子都抵达终点则判定为完成游戏。越快完成游戏名次越高。",
    lang80:
      "根据玩法模式，先完成游戏的玩家名次越高。例如第一个完成游戏的玩家为本局游戏的第一名，以此类推。",
    // lang81: "游戏结束之后，根据您的名次可以获得露水、声望奖励。",
    lang81: "游戏结束之后，根据您的名次可以获得露水。",
    lang82:
      "如果您在已加入的社团房间内贏得游戏，则根据游戏排名增加您在该社团中的声望。",
    lang83: "支付房主设定的入场露水，可以加入游戏。",
    lang84: "已经开始的游戏中，玩家可以在中途支付入场露水加入Ludo PK。",
    lang85: "需要骰子投到點數六，棋子才可以从基地起飛到起始格子。",
    lang86: "同意回合內累計投出3个點數六時，則觸發三連六，玩家跳過此回合。",
    lang87: "玩家投擲骰子获得點數，用以移動棋子前進對應的步數。",
    lang88:
      "相同玩家的棋子停留在同一處則成為疊子，被吃子時疊子會被全部踢回基地。",
    lang89:
      "棋子行動結束後落在的格子上如果有其他玩家的棋子，則將所有其他玩家的棋子踢回基地，需要重新起飛才可以進行行動。",
    lang90:
      "棋子落在棋盤上的起點和帶盾牌的格子，不會被吃子。不同玩家的棋子可以同時停留在這些格子上。",
    lang91:
      "每局游戏收取固定露水数量作为房费，房费金额根据入场露水数量确定，与游戏人数无关。游戏结算发放奖励露水时，系统将自动扣除房费后，发放赢家奖励露水",
    lang92: "加入游戏",
    lang93: "游戏房费",
    lang94: "胜场",
    lang95: "玩家",
    lang96: "结算露水",
    lang97: "场费",
    lang98: "底注",
    lang99: "/场",
    lang100: "我的成绩",
    lang101: "参与玩家",
    lang102: "记录",
  },

  // TeenPatti
  teenPatti: {
    recordTitle: "记录",
    rankingTitle: "排行榜",
    confirm: "确认",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "玩法设定",
    maxBet: "最大下露",
    maxPot: "最大底池",
    buyInDew: "带入露水",
    mockJoinTip: "模拟模式：已选择底露 {ante}，暂未接入加入接口",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "{club}的 PK 房间",
    // 三张牌规则页文案，统一由全局国际化管理。
    title: "玩法说明",
    hands: "牌型",
    play: "玩法",
    order: "牌力从高到低排列",
    players: "玩法人数：2–5人",
    mode: "玩法模式：",
    intro: "「三张牌」是一款基于三张扑克牌进行大小比对的策略博弈游戏。玩家需根据手中的牌型以及对手的下露行为进行判断，透过跟注、加注或比牌等行动，争夺最终的底池露水奖励。牌力不比较牌面花色大小。",
    flow: "游戏流程",
    ante: "底露",
    anteText: "游戏开始时，每位玩家将自动扣除固定的「底露」投入当局底池。底露数量由房主设定。",
    deal: "发牌阶段",
    dealText: "系统向每位参与玩家发放 3 张暗牌，只有玩家本人选择「看牌」后才可见自己的手牌。",
    turn: "回合操作",
    turnText: "系统按顺序轮流交由玩家进行操作，直到场上仅剩 1 名玩家，或达到底池上限或回合数上限为止。",
    actions: "玩家行动",
    blind: "暗牌状态",
    blindText: "玩家在未查看自己底牌的情况下进行下露。此状态下的跟注或加注为下露数量的 1 倍。",
    seen: "看牌状态",
    seenText: "玩家查看底牌后继续参与游戏。此状态下，玩家的跟注或加注将为暗牌玩家的 2 倍。",
    compare: "比牌",
    condition: "条件",
    conditionText: "每场游戏进入第 2 轮后，玩家可以选择是否发起比牌。",
    cost: "规则",
    costText: "发起比牌需支付当前单次下露额的 2 倍露水。",
    compareResult: "胜负判定",
    compareResultText: "发起者可指定场上任意一名活跃玩家进行暗中比牌，若双方牌型与点数完全一致，基于避险规则，主动发起比牌的一方将判定为输。输家将被淘汰出当局牌桌。",
    fold: "弃牌",
    foldText: "玩家主动放弃本局游戏，先前已投入底池的露水不予退还。",
    allIn: "All in",
    allInText: "当玩家余额不足以支付当前的最低跟注额时，可进行 All in，系统将剩余全部余额投入底池，随后本局内不可再进行任何操作。系统将为其保留手牌，直至最终回合进行强制摊牌比对。",
    settlement: "游戏结算",
    end: "回合上限",
    endText: "为保障游戏流畅度，每局游戏设有最大回合数限制（具体以房间显示为准）。",
    showdown: "强制开牌",
    showdownText: "当达到最大回合数，或场上仅剩 2 名玩家且其中一方发起明牌时，系统将强制公开剩余玩家的底牌进行最终比对。",
    reward: "露水奖励",
    rewardText: "最终胜出的玩家将赢得本池内的全部露水（系统将依平台规范扣除固定比例的服务费／抽成后发放）。",
    hand1: "豹子",
    desc1: "三张点数相同的牌，如 AAA、222 等",
    hand2: "顺金",
    desc2: "花色相同的顺子，如黑桃 456 等",
    hand3: "金花",
    desc3: "花色相同但非顺子的三张牌",
    hand4: "顺子",
    desc4: "花色不同的顺子，如红桃 5、方块 6、黑桃 7",
    hand5: "对子",
    desc5: "两张点数相同的牌加一张单张，如 223",
    hand6: "高牌",
    desc6: "不符合以上任何组合的普通牌",
    hand7: "235",
    desc7: "不同花色的 2、3、5 组成，仅在牌桌上有豹子存在时，235 吃豹子，其他情况下 235 只作为高牌计算。",
    rankOrder: "同类牌型按点数比较：A 最大，2 最小；豹子 AAA 最大、222 最小。顺金和顺子 A–K–Q 最大、3–2–A 最小。",
    sameHand: "金花与高牌先比较最大牌点数；相同则依次比较第二大、第三大牌。花色不比较大小。",
    samePair: "对子先比较对子点数；相同则比较单张点数。",
    lang1: "开启房间",
    lang2: "快速加入",
    lang3: "入场",
    lang4: "等待中",
    lang5: "当前暂无三张牌 PK 房间",
    lang6: "玩法模式",
    lang7: "默认俱乐部",
    lang8: "经典",
    lang9: "无限制",
    lang10: "战绩",
    lang11: "排行",
    lang12: "入场露水",
    lang13: "玩法信息",
    lang16: "支付入场露水加入Ludo PK",
    lang17: "玩家人数",
    lang18: "获胜奖励",
    lang19: "声望",
    lang20: "我的道具",
    lang21: "棋子",
    lang22: "棋盘",
    lang23: "选择您在LUDO游戏中使用的棋子道具。",
    lang24: "选择您的社团PK房间在LUDO游戏中使用的棋盘道具。",
    lang26: "已选择",
    lang27: "默认",
    lang28: "请选择道具",
    lang31: "使用",
    lang32: "点击选择要使用的道具",
    lang33: "点击使用，下一场LUDO游戏将使用该棋盘道具",
    lang34: "点击使用，下一场LUDO游戏将使用该棋子道具",
    lang35: "已在使用中",
    lang36: "请选择要使用的道具",
    lang37: "使用成功，下一场LUDO游戏生效",
    lang38: "天",
    lang39: "小时",
    lang40: "分钟",
    lang42: "当前暂无Teenpatti PK记录",
    lang43: "游戏详情",
    lang45: "房费",
    lang46: "时间",
    lang47: "露水",
    lang49: "日期",
    lang50: "总计",
    lang51: "玩家头像",
    lang52: "排名",
    lang57: "加载中...",
    lang58: "客服",
    lang59: "胜",
    lang60: "负",
    lang61: "平",
    lang62: "玩法说明",
    lang63: "游戏规则",
    lang64: "玩法人數",
    lang66: "胜负判定",
    lang68: "社团声望",
    lang69: "参与游戏",
    lang70: "中途加入",
    lang72: "起飞",
    lang73: "三連六",
    lang74: "行动",
    lang75: "疊子",
    lang76: "吃子",
    lang77: "安全區",
    lang78: "2-4人",
    lang79:
      "经典：玩家的棋子都需要从起点开始绕图一圈后到达终点，所有棋子都抵达终点则判定为完成游戏。越快完成游戏名次越高。",
    lang80:
      "根据玩法模式，先完成游戏的玩家名次越高。例如第一个完成游戏的玩家为本局游戏的第一名，以此类推。",
    // lang81: "游戏结束之后，根据您的名次可以获得露水、声望奖励。",
    lang81: "游戏结束之后，根据您的名次可以获得露水。",
    lang82:
      "如果您在已加入的社团房间内贏得游戏，则根据游戏排名增加您在该社团中的声望。",
    lang83: "支付房主设定的入场露水，可以加入游戏。",
    lang84: "已经开始的游戏中，玩家可以在中途支付入场露水加入Ludo PK。",
    lang85: "需要骰子投到點數六，棋子才可以从基地起飛到起始格子。",
    lang86: "同意回合內累計投出3个點數六時，則觸發三連六，玩家跳過此回合。",
    lang87: "玩家投擲骰子获得點數，用以移動棋子前進對應的步數。",
    lang88:
      "相同玩家的棋子停留在同一處則成為疊子，被吃子時疊子會被全部踢回基地。",
    lang89:
      "棋子行動結束後落在的格子上如果有其他玩家的棋子，則將所有其他玩家的棋子踢回基地，需要重新起飛才可以進行行動。",
    lang90:
      "棋子落在棋盤上的起點和帶盾牌的格子，不會被吃子。不同玩家的棋子可以同時停留在這些格子上。",
    lang91:
      "每局游戏收取固定露水数量作为房费，房费金额根据入场露水数量确定，与游戏人数无关。游戏结算发放奖励露水时，系统将自动扣除房费后，发放赢家奖励露水",
    lang92: "加入游戏",
    lang93: "游戏房费",
    lang94: "胜场",
    lang95: "玩家",
    lang96: "结算露水",
    lang97: "场费",
    lang98: "底露",
  },
};
